export const MAX_WORD_LENGTH = 5
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 3000
